var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.$route.meta.showLogin != true)?_c('Header',{ref:"header",staticStyle:{"z-index":"5"}}):_vm._e(),_c('router-view'),(_vm.$route.meta.showLogin2 != true)?_c('Footer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }